const Footer = () => {
    return <footer className="bg-black text-white text-center py-4">Footer Content</footer>;
  };
  
  export default Footer;
  